import React from "react";
import { useEffect, useState } from "react";


function Since() {
  const [years, setYears] = useState(0);

  useEffect(() => {
    const currentYear = new Date().getFullYear();
    const yearsSince1987 = currentYear - 1987;
    setYears(yearsSince1987);
  }, []);

  return (

    <div className="">

      <span >
        Helping Sea Turtles Survive for {years} Year{years === 1 ? '' : 's'}
      </span>

    </div>
  );

}

export default Since;